/**
 * Stretched-link overlay for a single `.btn` CTA inside a `position: relative`
 * container. Requires navigational buttons to render as one `a.btn` (see Btn*
 * components) with decorative layers on an inner `.btn-surface`.
 */
export const withCtaLinkOverlay = () => {
  return {
    '.btn': {
      position: 'static',
      '&::after': {
        content: '""',
        position: 'absolute',
        inset: 0,
        zIndex: 1,
      },
      '& .btn-surface, & > *': {
        position: 'relative',
        zIndex: 2,
      },
    },
    '& p a': {
      position: 'relative',
      zIndex: 2,
    },
  };
};
